<template>
  <div class="signup">
    <div class="title">
      请输入注册信息
    </div>
    <van-form @submit="onSubmit" ref="vanForm" label-width="4em" label-align="right">
      <van-field label="单位名称" class="name_field" v-model="form.orgName" placeholder="请输入单位名称" />
      <van-field label="手机号码" class="name_field" v-model="form.phone" placeholder="请输入您的手机号码" :rules="rules.phone" />
      <van-field label="姓名" class="name_field" v-model="form.userName" placeholder="请输入使用人" :rules="rules.name" />
      <van-field label="设置密码" class="name_field" v-model="form.password" placeholder="请输入密码" :rules="rules.password" />
      <van-field label="对接人 " class="name_field" v-model="form.contactPerson" placeholder="请输入对接人" />
      <div class="btn_wrap">
        <van-button block type="info" :disabled="btnLoading" :loading="loading" class="btn"
          native-type="submit">申请注册</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import imageUpload from '@/components/imageUpload'
import { geturl } from '@/utils/index';
import { register } from '@/api/index'
import { Toast } from 'vant';

export default {
  name: 'Signup',
  components: {
    imageUpload
  },
  data() {
    return {
      form: {
        orgName: '',
        phone: '',
        userName: '',
        password: '',
        contactPerson: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入您的姓名' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'onBlur' },
          { validator: this.validatorPhone, message: '请输入正确的手机号码', trigger: 'onBlur' },
        ],
        password: [
          { required: true, message: '请输入您密码' },
        ],
      },
      loading: false,
      btnLoading: false,
    }
  },
  mounted() {
    let params = geturl()
    if (params && params.openId) {
      const id = params.openId
      localStorage.setItem('id', id);
    }
    //设定苹果手机input框不自动放大监听
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    var lastTouchEnd = 0;
    document.addEventListener('touchend', function (event) {
      var now = (new Date()).getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);
  },
  methods: {
    validatorPhone(val) {
      // 手机号码验证
      return /^1[3-9]\d{9}$/.test(val);
    },
    onSubmit() {
      // 校验表单
      this.$refs.vanForm.validate().then(() => {
        // 判断this.form.photo是否为空
        this.loading = true;
        this.btnLoading = true
        this.form.openId = localStorage.getItem('id');
        let data = { ...this.form }
        register(data).then((res) => {
          console.log(res);
          this.loading = false;
          this.btnLoading = false
          Toast.success({
            duration: 3000, // 持续展示 toast
            forbidClick: true,
            message: '注册成功',
          });
          setTimeout(() => {
            this.$router.push({ path: 'login' });
          }, 3000)
        }).catch((err) => {
          console.log(err);
          this.loading = false;
          this.btnLoading = false
        });
      }).catch((error) => { });
    },
    onInput(file) {
      this.form.photo = file;
    },
    // 判断环境
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == 'micromessenger') { // 判断是否在微信浏览器内
        return true;
      } else {
        return false;
      }
    },
    // 微信内置浏览器关闭
    closePageWx() {
      // isWechat是我写的一个判断当前环境是否是微信内置浏览器 的方法
      if (!this.isWechat()) return // 非微信环境下，不做处理 
      setTimeout(function () {
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
          WeixinJSBridge.invoke('closeWindow', {}, function (res) {
            if (res.err_msg == "close_window:ok") {
              // 关闭成功的处理
              console.log('关闭成功的处理')
            } else {
              // 关闭失败的处理
              console.log('关闭失败的处理')
            }
          });
        }
      }, 100);
    },

    //关闭页面
    closePage() {
      if ((navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) && !this
        .isWechat()) {
        console.log('Firefox或者Chrome浏览器');
        window.location.href = 'about:blank'
        window.close()
      } else if (this.isWechat()) {
        console.log('微信内置浏览器');
        this.closePageWx()
      } else {
        console.log('其他浏览器');
        window.opener = null
        window.open('', '_self')
        window.close()
      }
    },
  },
}
</script>
<style scoped lang="less">
.signup {
  width: 80%;
  padding: 20px;
  margin: 0 auto;
  background-color: #fff;

  .title {
    margin: 20px 0;
    font-size: 0.16rem;
    font-weight: bold;
    text-align: center;

  }

  .name_field {
    margin-bottom: 10px;
  }

  .btn {
    background-color: rgba(43, 70, 138, 1);
    color: #fff;
    font-size: 0.14rem;
    text-align: center;
    font-family: Roboto;
    border-radius: 8px;
  }
}
</style>